<template>
  <div class="barOne"></div>
</template>

<script>
var timerId;
import { reqnavigationDoc } from "@/network/homePage";
export default {
  name: "BarOne",
  methods: {
    async getInitData(type=3) {
      let { data } = await reqnavigationDoc({type:type});
      if (data.code == 200) {
        var xData = [];
        var totalData = [];
        for (const item of data.data) {
          xData.push(item.name);
          totalData.push(item.total);
        }
      }
      this.$echarts.barone(this.myChart, {
        xData,
        totalData,
      });
    },
	clickSelect(val){
		this.getInitData(parseInt(val))
	}
  },
  watch: {
    "$store.state.opened"() {
      if (timerId) {
        // console.log(timerId);
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        this.myChart.resize();
      }, 300);
    },
  },
  mounted() {
    this.myChart = this.$init(document.querySelector(".barOne"));
    this.getInitData();
  },
  // beforeDestroy() {
  //   this.chart.clear();
  // },
};
</script>

<style lang="scss" scoped>
.barOne {
  width: 100%;
  height: 100%;
}
</style>
